import { Account } from "library/accounts/types";
import { Product } from "library/hooks/types";
import { Pages, State } from "./types";

export function getInitialState(account: Account, product: Product): State {
  const personalDetailsUrl = account.links.find(
    (link) => link.rel === "get_personal_details_unmasked",
  )?.href;

  if (!account.credit_card || !personalDetailsUrl) {
    return { page: Pages.ERROR };
  }

  const lostStolenDamagedUrl = account.links.find(
    (link) => link.rel === "lost_stolen_damaged",
  )?.href;

  if (!lostStolenDamagedUrl) {
    return {
      page: Pages.UNAVAILABLE,
    };
  }

  return {
    page: Pages.REPORT_LOST_STOLEN_OR_DAMAGED,
    scheme: product.scheme ?? "NON_SCHEME",
    cardEndsWith: account.credit_card.linked_card_last4,
    lostStolenDamagedUrl,
    personalDetailsUrl,
    token: account.credit_card.token,
  };
}
